import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    min-width: 280px;
    background: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgb(0 0 0 / 8%);
    z-index: 10;
    top: ${displayState?.openOnTop ? '' : '48px'};
    bottom: ${displayState?.openOnTop ? '48px' : ''};
    width: ${displayState?.width ? `${displayState.width}px` : ''};
    background-color: #FFFFFF;
    border-radius: 8px;
    left: ${displayState?.left ? displayState.left + 'px' : 'unset'};

    max-height: 300px;
    border: 1px solid #E3E3E3;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;
    /* width */
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #E3E3E3;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
  `}
`

export default Wrapper(template)